// Expose React and ReactDOM on window for Module Federation remotes.
//
// The host loads these via SystemJS (AMD path), which does NOT set window
// globals. Native webpack MF remotes need them available on window so the
// host's share-scope factory can provide them through the shared scope.
import React from 'react';
import ReactDOM from 'react-dom';

if (typeof window !== 'undefined') {
  window.React = React;
  window.ReactDOM = ReactDOM;
}

// Point webpack's runtime at the directory the app bundles load from so
// dynamically imported chunks (e.g. the lazily loaded ApplicationView and
// Braze chunks) resolve correctly. In production the bundles are served from a
// commit-hashed directory via a <base> tag, and app.bundle.js is `defer async`
// — so webpack's "auto" publicPath cannot infer the path from
// document.currentScript. Derive it from the depVersions script URL, which
// resolves against the same base as every other app bundle.
if (typeof document !== 'undefined') {
  const depVersionsScript = document.getElementById('depVersions');
  const src = depVersionsScript && depVersionsScript.src;
  if (src) {
    // eslint-disable-next-line camelcase, no-undef
    __webpack_public_path__ = src.slice(0, src.lastIndexOf('/') + 1);
  }
}
